import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { mapToDateTimeRange } from '@modules/common/utils';
import { TimeRangeResponse } from 'generated/graphql';

const OLD_DEFAULT_TIMESTAMP = 86400000;

export const getSavedTimeRange = ({
  timeRange,
}: {
  timeRange?: TimeRangeResponse;
}): DateTimeRange | undefined => {
  if (!timeRange) {
    return undefined;
  }

  const { startAfter } = timeRange;

  // For Backward compatibility, converting dates before 1st Jan 1970 to undefined
  const shouldSetDurationToDefault =
    startAfter && startAfter < OLD_DEFAULT_TIMESTAMP;

  if (shouldSetDurationToDefault) {
    return undefined;
  }

  return mapToDateTimeRange(timeRange);
};
